// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3wrxl","errors":"Errors_errors__1XQOi"};